"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var React = _interopRequireWildcard(require("react"));

var _redux = require("redux");

var _reactRedux = require("react-redux");

var _semanticUiReact = require("semantic-ui-react");

var _superSegments = require("../../reducers/superSegments");

var _actions = require("../../actions");

var _index = require("../../../index");

var _GenerateAdsGoogleMockup = _interopRequireDefault(require("./GenerateAdsGoogleMockup"));

var _GenerateAdsFacebookMockup = _interopRequireDefault(require("./GenerateAdsFacebookMockup"));

var _AdGeneratorConfig = require("./AdGeneratorConfig");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var GenerateAdsForm = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(GenerateAdsForm, _React$Component);

  function GenerateAdsForm(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "returnToForm", function () {
      //console.log('RETURN TO FORM UI');
      _this.setState(function (prevState) {
        return {
          showResults: !prevState.showResults
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputChange", function (event) {
      var formData = Object.assign({}, _this.state.formData);
      formData[event.target.name] = event.target.value;

      _this.setState({
        formData: formData
      });
    });

    _defineProperty(_assertThisInitialized(_this), "generateGoogleAds", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var formData, sections, briefSections, generatedPrompts, prompt, results;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              formData = _this.state.formData;
              sections = _this.state.streamMeta.sections;
              briefSections = (0, _AdGeneratorConfig.generateSectionPrompts)(sections); // Update State Prompts

              generatedPrompts = _this.state.generatedPrompts;
              prompt = (0, _AdGeneratorConfig.generateGoogleAdPrompt)(formData, briefSections);
              generatedPrompts.google = prompt;

              _this.setState({
                generatedPrompts: generatedPrompts
              }); // Send Request


              _context.next = 9;
              return _this.sendReqest(prompt);

            case 9:
              results = _context.sent;

              if (results !== undefined) {
                _this.setState({
                  googleResults: results
                });
              }

              return _context.abrupt("return", true);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "generateFacebookAds", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var formData, sections, briefSections, generatedPrompts, prompt, results;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              formData = _this.state.formData;
              sections = _this.state.streamMeta.sections;
              briefSections = (0, _AdGeneratorConfig.generateSectionPrompts)(sections); // Update State Prompts

              generatedPrompts = _this.state.generatedPrompts;
              prompt = (0, _AdGeneratorConfig.generateFacebookAdPrompt)(formData, briefSections);
              generatedPrompts.facebook = prompt;

              _this.setState({
                generatedPrompts: generatedPrompts
              }); // Send Request


              _context2.next = 9;
              return _this.sendReqest(prompt);

            case 9:
              results = _context2.sent;

              if (results !== undefined) {
                _this.setState({
                  facebookResults: results
                });
              }

              return _context2.abrupt("return", true);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee3(submittedForm) {
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!_this.state.formLoading) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                _this.setState({
                  formData: submittedForm,
                  promptType: 'google',
                  formLoading: true,
                  showResults: false
                });

                _context3.next = 5;
                return _this.generateGoogleAds();

              case 5:
                _context3.next = 7;
                return _this.generateFacebookAds();

              case 7:
                _this.setState({
                  formLoading: false,
                  showResults: true
                });

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "sendReqest", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee4(myPrompt) {
        var chatGPTsecretKey, token, body, targetUrl, fullHeaders, response, json, results;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                //console.log('**** CHATGPT REQUEST ****');
                //console.log('FORM DATA: ', this.state.formData);
                //console.log(myPrompt);
                chatGPTsecretKey = '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';
                token = "Bearer " + chatGPTsecretKey; // Validate Form Inputs
                // Prepare ChatGPT Request

                body = {
                  model: 'gpt-4',
                  messages: [{
                    role: 'user',
                    content: myPrompt
                  }]
                };
                targetUrl = 'https://api.openai.com/v1/chat/completions';
                fullHeaders = new Headers({
                  Authorization: token,
                  'Content-Type': 'application/json'
                }); // Send

                _context4.next = 7;
                return fetch(targetUrl, {
                  method: 'post',
                  headers: fullHeaders,
                  body: JSON.stringify(body)
                });

              case 7:
                response = _context4.sent;

                if (!response.ok) {
                  _context4.next = 16;
                  break;
                }

                _context4.next = 11;
                return response.json();

              case 11:
                json = _context4.sent;

                if (!(json.choices && json.choices.length > 0)) {
                  _context4.next = 15;
                  break;
                }

                results = JSON.parse(json.choices[0].message.content); //console.log('PARSED CONTENT: ', results);

                return _context4.abrupt("return", results);

              case 15:
                return _context4.abrupt("return", undefined);

              case 16:
                return _context4.abrupt("return", undefined);

              case 17:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x2) {
        return _ref4.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "toggleResults", function (promptType) {
      if (promptType === 'google') {
        _this.setState({
          promptType: 'google'
        });
      } else if (promptType === 'facebook') {
        _this.setState({
          promptType: 'facebook'
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "downloadResultsCSV", function () {
      // TODO: build a tool to process the generated results and export as CSV
      return true;
    });

    _this.state = {
      formLoading: false,
      googleLoading: false,
      facebookLoading: false,
      showResults: false,
      formData: {
        company: '',
        url: '',
        about: '',
        services: '',
        proposition: '',
        primary: '',
        secondary: '',
        businessType: ''
      },
      generatedPrompts: {
        google: '',
        facebook: ''
      },
      promptType: 'google',
      googleResults: {
        headlines: [],
        descriptions: [],
        adCopy: []
      },
      facebookResults: {
        headlines: [],
        descriptions: [],
        adCopy: []
      },
      streamMeta: {
        sections: props.briefSections,
        personas: props.personas,
        quadrant: props.selectedQuadrant
      }
    };
    return _this;
  }

  var _proto = GenerateAdsForm.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$state$formData = this.state.formData,
        company = _this$state$formData.company,
        url = _this$state$formData.url,
        about = _this$state$formData.about,
        services = _this$state$formData.services,
        proposition = _this$state$formData.proposition,
        primary = _this$state$formData.primary,
        secondary = _this$state$formData.secondary,
        businessType = _this$state$formData.businessType;
    var _this$state = this.state,
        googleResults = _this$state.googleResults,
        facebookResults = _this$state.facebookResults,
        formLoading = _this$state.formLoading,
        showResults = _this$state.showResults,
        promptType = _this$state.promptType;
    var _this$state$streamMet = this.state.streamMeta,
        quadrant = _this$state$streamMet.quadrant,
        personas = _this$state$streamMet.personas;
    var data = {
      company: company,
      url: url
    };
    var results = {
      headlines: [],
      descriptions: [],
      adCopy: []
    };

    if (promptType === 'google') {
      results.headlines = googleResults.headlines;
      results.descriptions = googleResults.descriptions;
    } else if (promptType === 'facebook') {
      results.headlines = facebookResults.headlines || [];
      results.descriptions = facebookResults.descriptions || [];
      results.adCopy = facebookResults.adCopy || [];
    }

    var pageStyle = {
      display: 'flex',
      width: '1200px',
      padding: '40px 64px 64px 64px',
      flexDirection: 'column',
      alignItems: 'center',
      borderRadius: '16px',
      background: '#FFF'
    };
    var pageInnerStyle = {
      display: 'flex',
      paddingTop: '24px',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '40px',
      alignSelf: 'stretch'
    };
    var pageHeaderStyle = {
      color: 'var(--helix-black, #23211D)',
      textAlign: 'center',
      fontFamily: 'Proxima Nova',
      fontSize: '32px',
      fontStyle: 'normal',
      fontWeight: '700',
      lineHeight: '150%',
      // You can use a string for this value
      textTransform: 'uppercase'
    };
    var personaList = {
      display: 'flex'
    };
    var promptTypeList = {
      display: 'inline-flex',
      padding: '8px 16px',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '12px',
      borderRadius: '9px',
      background: '#F3F5F7',
      width: '100%'
    };
    var promptListItem = {
      color: 'blue'
    };
    var personaListItem = {
      display: 'flex',
      padding: '6.51px 14.01px 7.49px 9.99px',
      alignItems: 'center',
      borderRadius: '4px',
      background: '#F3F5F7'
    };
    var personaTextStyle = {
      color: 'var(--helix-grey-dark, #596475)',
      fontFamily: 'Proxima Nova',
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: '700',
      lineHeight: '12px' // You can use a string for this value

    };
    var formStyle = {
      width: '100%'
    };
    var formInputStyle = {
      color: 'var(--helix-grey-dark, #596475)',
      fontFamily: 'Proxima Nova',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: '150%',
      // You can use a string for this value
      background: 'var(--helix-grey-light, #F3F5F7)'
    };
    var textAreaStyle = {
      background: '#F3F5F7',
      height: '104px'
    };
    var resultTitleStyle = {
      alignSelf: 'stretch',
      color: '#27251F',
      fontFamily: 'Proxima Nova',
      fontSize: '20px',
      fontStyle: 'normal',
      fontWeight: '700',
      lineHeight: '25.6px',
      // You can use a string for this value
      marginTop: '20px'
    };
    var resultListTyle = {
      color: '#27251F',
      fontFamily: 'Proxima Nova',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: '25.6px',
      // You can use a string for this value
      alignSelf: 'stretch'
    };
    var mockupWrapper = {
      display: 'flex',
      padding: '16px',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '24px',
      borderRadius: '9px',
      background: '#F3F5F7'
    };
    var activePromptTypeButton = {
      display: 'flex',
      padding: '4px 10px 4px 6px',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '8px',
      borderRadius: '4px',
      background: '#00ACCA',
      color: '#FFF'
    };
    var promptTypeButton = {
      display: 'flex',
      padding: '4px 10px 4px 6px',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '8px',
      borderRadius: '4px',
      color: '#596475',
      background: '#FFF'
    };
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_semanticUiReact.Container, null, /*#__PURE__*/React.createElement("div", {
      className: "ad-generator__page",
      style: pageStyle
    }, !showResults ? /*#__PURE__*/React.createElement("div", {
      className: "ad-generator__page-inner",
      style: pageInnerStyle
    }, /*#__PURE__*/React.createElement("h2", {
      className: "header__title",
      style: pageHeaderStyle
    }, "GENERATE AD"), /*#__PURE__*/React.createElement("div", {
      className: "personas__list",
      style: personaList
    }, personas && personas.length > 0 && personas.map(function (persona, key) {
      return /*#__PURE__*/React.createElement("div", {
        key: key,
        className: "personas__list-item",
        style: personaListItem
      }, /*#__PURE__*/React.createElement("span", {
        style: personaTextStyle
      }, persona.id + " - " + persona.name));
    })), /*#__PURE__*/React.createElement("div", {
      className: "generate-ads__ads-form",
      style: formStyle
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Form, null, /*#__PURE__*/React.createElement(_semanticUiReact.Form.Input, {
      label: "Company Name",
      placeholder: "Eg. Company A",
      name: "company",
      type: "text",
      required: true,
      value: company,
      style: formInputStyle,
      onChange: this.handleInputChange,
      disabled: formLoading
    }), /*#__PURE__*/React.createElement(_semanticUiReact.Form.Input, {
      label: "Paste your Website URL",
      placeholder: "Eg. companya.com.au",
      name: "url",
      type: "text",
      required: true,
      value: url,
      onChange: this.handleInputChange,
      disabled: formLoading
    }), /*#__PURE__*/React.createElement(_semanticUiReact.Form.Input, {
      label: "What Field does this business ",
      placeholder: "Eg. Digital Agency",
      name: "businessType",
      type: "text",
      required: true,
      value: businessType,
      onChange: this.handleInputChange,
      disabled: formLoading
    }), /*#__PURE__*/React.createElement(_semanticUiReact.Form.TextArea, {
      label: "Tell us about your company in 50 words or less",
      placeholder: "Eg. Company A helps people explore cities differently. With our curate guidebooks you can find the best hidden local spots, not just the famous tourist sites. We have guidebooks in over 50 Locations worldwide",
      name: "about",
      type: "textarea",
      required: true,
      value: about,
      style: textAreaStyle,
      onChange: this.handleInputChange,
      disabled: formLoading
    }), /*#__PURE__*/React.createElement(_semanticUiReact.Form.TextArea, {
      label: "Tell us about the products or services you are looking to advertise",
      placeholder: "Eg. Our melbourne Guidebook has been launched this week. It features over 200 ideas of places to go to.",
      name: "services",
      value: services,
      type: "textarea",
      required: true,
      style: textAreaStyle,
      onChange: this.handleInputChange,
      disabled: formLoading
    }), /*#__PURE__*/React.createElement(_semanticUiReact.Form.TextArea, {
      label: "Tell us about your unique value proposition",
      placeholder: "Eg. Unlike ordinary travel guides, our guides weave captivating stories, time-travel narratives, and eco-conscious trails. We're not just guides; we're your gateway to the extraordinary, making every journey a memory to treasure.",
      name: "proposition",
      required: true,
      type: "textarea",
      style: textAreaStyle,
      value: proposition,
      onChange: this.handleInputChange,
      disabled: formLoading
    }), /*#__PURE__*/React.createElement(_semanticUiReact.Form.TextArea, {
      label: "What are your primary keywords?",
      placeholder: "Eg. Travel guides, city exploration, hidden gems, immersive experiences, curated maps.",
      name: "primary",
      type: "textarea",
      value: primary,
      required: true,
      style: textAreaStyle,
      onChange: this.handleInputChange,
      disabled: formLoading
    }), /*#__PURE__*/React.createElement(_semanticUiReact.Form.TextArea, {
      label: "What are your secondary keywords?",
      placeholder: "Eg. Historical tales, local haunts, off-the-beaten-path, cultural treasures, culinary journeys, sustainable travel, virtual exploration.",
      name: "secondary",
      type: "textarea",
      required: true,
      value: secondary,
      style: textAreaStyle,
      onChange: this.handleInputChange,
      disabled: formLoading
    }), /*#__PURE__*/React.createElement(_semanticUiReact.Button, {
      onClick: function onClick() {
        _this2.handleSubmit({
          company: company,
          url: url,
          about: about,
          services: services,
          proposition: proposition,
          primary: primary,
          secondary: secondary,
          businessType: businessType
        });
      },
      type: "submit",
      loading: formLoading,
      style: {
        padding: '8px 20px'
      }
    }, "Generate Ad")))) : /*#__PURE__*/React.createElement("div", {
      className: "ad-generator__page-inner",
      style: pageInnerStyle
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Grid, null, /*#__PURE__*/React.createElement(_semanticUiReact.Grid.Column, {
      width: 12,
      alignItems: "left"
    }, /*#__PURE__*/React.createElement("button", {
      onClick: this.returnToForm,
      style: {
        "float": 'left'
      }
    }, '< Back to Company Details')), /*#__PURE__*/React.createElement(_semanticUiReact.Grid.Column, {
      width: 12
    }, /*#__PURE__*/React.createElement("div", {
      className: "generate-ads__header"
    }, /*#__PURE__*/React.createElement("h2", {
      className: "header__title",
      style: pageHeaderStyle
    }, "Generate Ad Copy"), /*#__PURE__*/React.createElement("div", {
      className: "personas__list",
      style: promptTypeList
    }, /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        return _this2.toggleResults('google');
      },
      style: promptType === 'google' ? activePromptTypeButton : promptTypeButton
    }, "Google"), /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        return _this2.toggleResults('facebook');
      },
      style: promptType === 'facebook' ? activePromptTypeButton : promptTypeButton
    }, "Facebook")))), /*#__PURE__*/React.createElement(_semanticUiReact.Grid.Column, {
      width: 6
    }, /*#__PURE__*/React.createElement("div", {
      className: "generate-ads__results-left-column",
      style: {
        gap: '32px'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "results__headlines"
    }, results && results.headlines && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h3", {
      style: resultTitleStyle
    }, "Your Suggested Headlines:"), /*#__PURE__*/React.createElement("div", {
      className: "headlines__inner",
      style: resultListTyle
    }, results.headlines.length > 0 ? results.headlines.map(function (headline, key) {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '10px'
        },
        key: key
      }, key + 1, ". ", headline);
    }) : 'No Results'))), /*#__PURE__*/React.createElement("div", {
      className: "results__descriptions"
    }, results && results.descriptions && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h3", {
      style: resultTitleStyle
    }, "Your Suggested Descriptions:"), /*#__PURE__*/React.createElement("div", {
      className: "descriptions__inner",
      style: resultListTyle
    }, results.descriptions.length > 0 ? results.descriptions.map(function (description, key) {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '10px'
        },
        key: key
      }, key + 1, ". ", description);
    }) : 'NO RESULTS'))), /*#__PURE__*/React.createElement("div", {
      className: "results__adcopy"
    }, results && results.adCopy && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h3", {
      style: resultTitleStyle
    }, "Your Suggested Ad Copy:"), /*#__PURE__*/React.createElement("div", {
      className: "adcopy__inner",
      style: resultListTyle
    }, results.adCopy.length > 0 ? results.adCopy.map(function (adCopy, key) {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '10px'
        },
        key: key
      }, key + 1, ". ", adCopy);
    }) : 'NO RESULTS'))), /*#__PURE__*/React.createElement("div", {
      className: "results__download-csv",
      style: {
        marginTop: '20px'
      }
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Button, {
      onClick: function onClick() {
        return _this2.downloadResultsCSV();
      },
      type: "button"
    }, "Download CSV")))), /*#__PURE__*/React.createElement(_semanticUiReact.Grid.Column, {
      width: 6
    }, /*#__PURE__*/React.createElement("div", {
      className: "generate-ads__results-right-column"
    }, /*#__PURE__*/React.createElement("div", {
      className: "results-right-column__inner",
      style: mockupWrapper
    }, promptType === 'google' ? /*#__PURE__*/React.createElement(_GenerateAdsGoogleMockup["default"], {
      results: googleResults,
      data: data
    }) : /*#__PURE__*/React.createElement(_GenerateAdsFacebookMockup["default"], {
      results: facebookResults,
      data: data
    })))))))));
  };

  return GenerateAdsForm;
}(React.Component);

var mapStateToProps = function mapStateToProps(state) {
  var workflowPermission = state.options.permissions.workflowPermission;
  return {
    formLoading: state.superSegments.formLoading,
    communityImages: (0, _superSegments.getCommunityImages)(state),
    campaignCreatorAccess: state.featureAccess.byId && state.featureAccess.byId[workflowPermission] && state.featureAccess.byId[workflowPermission].hasAccess,
    firstLandingPage: state.campaignCreator.options.firstLandingPage
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    loadSuperSegments: _actions.loadSuperSegments,
    featureAccess: _index.featureAccess
  }, dispatch);
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(GenerateAdsForm);

exports["default"] = _default;